import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { applicationTerminalService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetTerminalListByAppIdQueryProps = {
	applicationId: string;
};

const useGetTerminalListByAppIdQuery = ({
	applicationId,
}: useGetTerminalListByAppIdQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["terminalListByAppId", applicationId],
		() =>
			applicationTerminalService.getTerminalList({
				applicationId,
				// TODO: RC-5207 - add fetching if more then 100 items
				page: 0,
			}),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!applicationId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetTerminalListByAppIdQuery;
